import { createContext } from 'react';

type ModuleContextType = {
    index: number;
};

export const ModuleContext = createContext<ModuleContextType>({ index: 1 });
